<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    title="选择车间"
    width="800px"
    top="8vh"
  >
    <TableSelect
      :filter="filter"
      ref="tableSelect"
      :columns="columns"
      module="basic"
      url="workshops"
      @select="selectWorkShop"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" ref="form" :model="filter">
          <el-form-item label="车间编号" prop="workshopNo">
            <el-input v-model.trim="filter.workshopNo" placeholder="请输入车间编号" clearable />
          </el-form-item>
          <el-form-item label="车间名称" prop="workshopName">
            <el-input v-model.trim="filter.workshopName" placeholder="请输入车间名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </TableSelect>
  </el-dialog>
</template>

<script>
import TableSelect from "@/components/TableSelect.vue";

export default {
  components: { TableSelect },
  data() {
    return {
      dialogVisible: false,
      filter: {
        workshopNo: "",
        workshopName: "",
      },
      columns: [
        {
          title: "车间编号",
          key: "workshopNo",
          width: 100,
          align: "center",
        },
        {
          title: "车间名称",
          key: "workshopName",
          minWidth: 150,
        },
        {
          title: "所属工厂",
          key: "factoryName",
          minWidth: 150,
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          align: "center",
        },
      ],
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.$refs.tableSelect.loadData();
      });
    },

    // 选择车间
    selectWorkShop(row) {
      this.dialogVisible = false;
      this.$emit("select", row);
    },

    // 重置
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
      this.$refs.tableSelect.loadData(1);
    },
  },
};
</script>
